<template>
  <div class="quiz-item-container">
    <QuizItem
      :description="description"
      :image="imageProcessed"
      @click="openNext"
    />
  </div>
</template>

<script>
import store from "@/store";
import config from "@/api/config";
import { loadProgramData } from "@/utils";
import { Routes } from "@/constants";

import QuizItem from "@/components/QuizItem";

export default {
  name: "QuizItemContainer",
  components: {
    QuizItem
  },
  props: {
    description: {
      type: String,
      default: undefined
    },
    nextQuestions: {
      type: [Array, String],
      default: function() {
        return [];
      },
      required: false
    },
    program: {
      type: [String, Object, null],
      default: null,
      required: false
    },
    title: {
      type: String,
      default: undefined,
      required: false
    },
    image: {
      type: [Object, String, null],
      default: null,
      required: false
    }
  },
  methods: {
    openNext: function() {
      if (this.program) {
        this.showResult();
      } else if (this.nextQuestions) {
        this.nextQuestionsList();
      }
    },
    nextQuestionsList: function() {
      const idObject = { id_list: [], heading: "" };
      if (this.title) {
        idObject.heading = this.title;
      }
      this.nextQuestions.forEach(item => {
        idObject.id_list.push(item._id);
      });
      store.commit("setQuestionQueue", idObject);
    },
    showResult: function() {
      store.commit("setResultProgram", this.program._id);
      store.commit(
        "setResultImage",
        loadProgramData(this.program._id).image.path
      );
      this.$router.push(Routes.result.path);
    }
  },
  computed: {
    imageProcessed: function() {
      const storageURL = config.STORAGE_URL;
      if (this.image) {
        return storageURL + this.image.path;
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.quiz-item-container {
  display: flex;
  height: 100%;
}
</style>
